module.exports = __webpack_public_path__ + "static/img/head_6.2957d9e4.png";